import './styles.css';

import React from "react";
import { Spinner } from 'react-bootstrap';

import { useSelector, useDispatch } from 'react-redux';
import { showLoad, dismissLoad, selectLoading } from '../../store/slice/loading';

export function App() {

    const [loading, setLoading] = React.useState(false);
    const stateLoad = useSelector(selectLoading);

    React.useEffect(() => {
        setLoading(stateLoad.status);
    }, [stateLoad]);

    return (
        loading ?
            <div className='loading-content'>
                <Spinner animation="border" variant="light" />
                <p className='text' style={{ fontSize: 30, fontWeight: "bolder", color: "white" }}>Loading...</p>
            </div > : (null)
    );

}

export function ShowLoading() {
    // console.log("ShowLoading");
    const dispatch = useDispatch();
    dispatch(showLoad());
}

export function CloseLoading() {
    // console.log("CloseLoading");
    const dispatch = useDispatch();
    dispatch(dismissLoad());
}

export default App;